import React        from 'react';
import PropTypes    from 'prop-types';

import {useSortable} from '@dnd-kit/sortable';
import {CSS}         from '@dnd-kit/utilities';

import PhotoSelect   from './PhotoSelect';

// PhotoSelect'in sürüklenebilir hali. Sürükleme ref'i PhotoSelect'in kendi kök div'ine
// geçer; araya sarmalayıcı eklenmediği için .room-photo-grid flex düzeni korunur.
const SortablePhotoSelect = ({sortableId, sortableDisabled, ...photoSelectProps}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({id: sortableId, disabled: sortableDisabled});

    return (
        <PhotoSelect
            {...photoSelectProps}
            draggable={false}
            innerRef={setNodeRef}
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
                opacity: isDragging ? 0.4 : undefined,
                zIndex: isDragging ? 20 : undefined,
            }}
            showDragHandle={!sortableDisabled}
            dragHandleProps={{...attributes, ...listeners}}
        />
    );
};

SortablePhotoSelect.propTypes = {
    sortableId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    // true ise fotoğraf sürüklenemez ve başkasının üzerine bırakılacağı hedef olmaz
    sortableDisabled: PropTypes.bool,
};

export default SortablePhotoSelect;
